export const FETCH_CATEGORY = 'FETCH_CATEGORY';
export const FETCH_MODIFIER = 'FETCH_MODIFIER';

export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';

export const ADD_MODIFIER = 'ADD_MODIFIER';
export const REMOVE_MODIFIER = 'REMOVE_MODIFIER';

export const CHANGE_QUANTITY = 'CHANGE_QUANTITY';

export const FETCH_UPSELL = 'FETCH_UPSELL';

export const RESET_ALL = 'RESET_ALL';



// WEBPACK FOOTER //
// ./src/business-logic/state/actions/actionTypes.js